import {ModelsAvatar} from '../../../components/ModelsAvatar'
import {GitHubAvatar} from '@github-ui/github-avatar'
import type {ModelState} from '../../../types'
import {Spinner} from '@primer/react'
import styles from './PlaygroundChatAvatar.module.css'
import {testIdProps} from '@github-ui/test-id-props'

export interface PlaygroundChatAvatarProps {
  isLoading?: boolean
  avatarUrl: string
  messageRole: string
  model: ModelState
}

export function PlaygroundChatAvatar({isLoading, avatarUrl, messageRole, model}: PlaygroundChatAvatarProps) {
  const avatar =
    messageRole === 'assistant' || messageRole === 'error' ? (
      <ModelsAvatar square={false} model={model.catalogData} size={24} />
    ) : (
      <GitHubAvatar src={avatarUrl} size={24} />
    )

  return (
    <div className="d-flex flex-items-center position-relative">
      {avatar}
      {isLoading && (
        <div className={styles.spinnerContainer} {...testIdProps('playground-avatar-spinner')}>
          <Spinner size="medium" className="fgColor-accent" />
        </div>
      )}
    </div>
  )
}

try{ PlaygroundChatAvatar.displayName ||= 'PlaygroundChatAvatar' } catch {}